import { Box, Grid, Typography } from "@mui/material";
import Input from "../../../../../../components/Input";
import { useBodyRemovalDetailsStore } from "../../../../../../store/useBodyRemovalDetailsStore";

export default function BodyRemovalDetails({ errors, showErrors }: any) {
  const { deceasedLocation, setBodyRemovalDetails } =
    useBodyRemovalDetailsStore();

  const handleChange = (field: string, value: string) => {
    console.log(value, "value");
    let updatedFields: any = { [field]: value };
    setBodyRemovalDetails(updatedFields);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            fullWidth
            label="House/Unit Number*"
            variant="outlined"
            value={deceasedLocation.houseNumber}
            onChange={(e: any) => handleChange("houseNumber", e.target.value)}
            error={showErrors && Boolean(errors.houseNumber)}
            helperText={showErrors ? errors.houseNumber : ""}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            fullWidth
            label="Street Name*"
            variant="outlined"
            value={deceasedLocation.streetName}
            onChange={(e: any) => handleChange("streetName", e.target.value)}
            error={showErrors && Boolean(errors.streetName)}
            helperText={showErrors ? errors.streetName : ""}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            fullWidth
            label="Suburb/Area*"
            variant="outlined"
            value={deceasedLocation.suburb}
            onChange={(e: any) => handleChange("suburb", e.target.value)}
            error={showErrors && Boolean(errors.suburb)}
            helperText={showErrors ? errors.suburb : ""}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            fullWidth
            label="City/Town*"
            variant="outlined"
            value={deceasedLocation.city}
            onChange={(e: any) => handleChange("city", e.target.value)}
            error={showErrors && Boolean(errors.city)}
            helperText={showErrors ? errors.city : ""}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            fullWidth
            label="Province*"
            variant="outlined"
            value={deceasedLocation.province}
            onChange={(e: any) => handleChange("province", e.target.value)}
            error={showErrors && Boolean(errors.province)}
            helperText={showErrors ? errors.province : ""}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            fullWidth
            label="Postal Code*"
            variant="outlined"
            value={deceasedLocation.postalCode}
            onChange={(e: any) => handleChange("postalCode", e.target.value)}
            error={showErrors && Boolean(errors.postalCode)}
            helperText={showErrors ? errors.postalCode : ""}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Input
            fullWidth
            label="Notes / Remraks*"
            variant="outlined"
            value={deceasedLocation.notes}
            onChange={(e: any) => handleChange("notes", e.target.value)}
            error={showErrors && Boolean(errors.notes)}
            helperText={showErrors ? errors.notes : ""}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
